export function convert<T, V>(
  value: T,
  formatter: (value: NonNullable<T>) => V,
): Extract<T, undefined> | V;

export function convert(
  value: null | undefined,
  formatter: (value: null | undefined) => unknown,
): undefined;

export function convert<T, R>(value: T, callback: (value: NonNullable<T>) => R): R | undefined {
  if (value == null) return undefined;
  if (value == 'null') return undefined;
  return callback(value);
}
